module.exports = __webpack_public_path__ + "static/pic14.cb63ac6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic14.jpg
// module id = 537
// module chunks = 35783957827783